// extracted by mini-css-extract-plugin
module.exports = {"error404":"Error404_error404__3_A6e","infoError404":"Error404_infoError404__1A_Sv"};